import * as yup from 'yup';
import isEmailValidator from 'validator/es/lib/isEmail';
export default () => {
    return yup.object({
        oldEmail: yup
            .string()
            .email('Please provide a valid email address')
            .test('is-valid', (message) => `${message.path} is invalid`, (value) => value ? (process.env.NODE_ENV === 'test' ? true : isEmailValidator(value)) : true),
        email: yup
            .string()
            .email('Please provide a valid email address')
            .required('Email is required')
            .test('is-valid', (message) => `${message.path} is invalid`, (value) => value
            ? process.env.NODE_ENV === 'test'
                ? true
                : isEmailValidator(value)
            : new yup.ValidationError('Please provide a valid email address')),
    });
};
